(function(window, document){
  'use strict';

  function esc(value){
    return String(value == null ? '' : value).replace(/[&<>"']/g,function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function money(value){
    if (value == null || !Number.isFinite(Number(value))) return 'Quote';
    return new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD',maximumFractionDigits:0}).format(Number(value));
  }
  function titleLayout(layout){
    return ({centre:'Centre',left:'Left',right:'Right',double:'Double'})[layout] || layout || '';
  }
  function byId(list,id){ return (list || []).find(function(item){ return item.id === id; }) || null; }

  function init(){
    var data=window.ADPTheaData;
    var root=document.querySelector('[data-adp-thea-five]');
    var configurator=document.querySelector('[data-adp-thea-configurator]');
    if(!data || !root || !configurator || root.dataset.theaReady==='true') return;
    root.dataset.theaReady='true';
    root.dataset.theaUiBuild='thea-describe-eli-detail-v3';

    var input=root.querySelector('[data-adp-thea-describe]');
    var clearDescribe=root.querySelector('[data-adp-thea-clear]');
    var results=root.querySelector('[data-adp-thea-results]');
    var groups=root.querySelector('[data-adp-thea-groups]');
    var baseText=root.querySelector('[data-adp-thea-base]');
    var strip=root.querySelector('[data-adp-thea-strip]');
    var stripText=root.querySelector('[data-adp-thea-strip-text]');
    var stripChoices=root.querySelector('[data-adp-thea-strip-choices]');
    var stripDimensions=root.querySelector('[data-adp-thea-strip-dimensions]');
    var stripSku=root.querySelector('[data-adp-thea-strip-sku]');
    var stripPrice=root.querySelector('[data-adp-thea-strip-price]');
    var priceEl=root.querySelector('[data-adp-thea-price]');
    var quoteSummary=root.querySelector('[data-adp-thea-order-summary]');
    var changeBase=root.querySelector('[data-adp-thea-change-base]');
    var continueQuote=root.querySelector('[data-adp-thea-continue-quote]');
    var copySummary=root.querySelector('[data-adp-thea-copy-summary]');
    var handleCatalog=(window.ADPTheaHandlesData || data.handles || []).slice();
    var basinCatalog=[]
      .concat(window.ADPTheaBasinsAHData || [])
      .concat(window.ADPTheaBasinsIPData || [])
      .concat(window.ADPTheaBasinsQZData || []);

    var state={
      base:null,
      system:null,
      cabinet:null,
      topFinish:null,
      imperialFinish:null,
      benchtopUpgrade:null,
      basin:null,
      handle:null,
      wasteUpgrade:null,
      tapHole:null
    };

    // Presentation state is separate from Thea's product/price dependencies.
    var view={expanded:{}};
    var stripAnchor=document.createElement('div');
    stripAnchor.className='adp-thea-five__base-strip-anchor';
    strip.parentNode.insertBefore(stripAnchor,strip);

    function resetDependent(){
      state.topFinish=null;
      state.imperialFinish=null;
      state.benchtopUpgrade=null;
      state.basin=null;
      state.tapHole=null;
    }

    function allBaseRows(){
      var out=[];
      data.base_intents.forEach(function(item){
        item.layouts.forEach(function(layout){ out.push({width:item.width,layout:layout,custom:false}); });
      });
      return out;
    }

    function parseWidth(q){
      var unitMatch=q.match(/\b(\d+(?:\.\d+)?)\s*(mm|cm|m)\b/i);
      if(unitMatch){
        var n=Number(unitMatch[1]);
        var factor=unitMatch[2].toLowerCase()==='m'?1000:unitMatch[2].toLowerCase()==='cm'?10:1;
        return Math.round(n*factor);
      }
      var plain=q.match(/\b(\d{3,4})\b/);
      return plain?Number(plain[1]):null;
    }

    function describeIntent(){
      var q=(input && input.value || '').trim().toLowerCase();
      var width=parseWidth(q);
      var layout=null;
      var basinCount=null;
      if(/\b(double|two\s*(?:basins?|bowls?)|2\s*(?:basins?|bowls?)|twin\s*(?:basins?|bowls?))\b/.test(q)){
        layout='double';
        basinCount=2;
      } else {
        if(/\bleft(?:\s+offset)?\b/.test(q)) layout='left';
        else if(/\bright(?:\s+offset)?\b/.test(q)) layout='right';
        else if(/\b(centre|center|middle)\b/.test(q)) layout='centre';
        if(layout || /\b(single|one\s*(?:basin|bowl)|1\s*(?:basin|bowl))\b/.test(q)) basinCount=1;
      }
      return {
        q:q,
        width:width,
        layout:layout,
        basinCount:basinCount,
        hasCore:width!==null || layout!==null || basinCount!==null,
        invalidWidth:width!==null && (width<data.custom_width.min || width>data.custom_width.max)
      };
    }

    function parseDescribe(intent){
      if(!intent.q || !intent.hasCore || intent.invalidWidth) return [];
      var isStandard=intent.width!==null && data.base_intents.some(function(x){return x.width===intent.width;});
      if(intent.width!==null && !isStandard){
        return [{width:intent.width,layout:intent.layout,custom:true,requestedBasinCount:intent.basinCount}];
      }
      var rows=allBaseRows();
      if(intent.width!==null) rows=rows.filter(function(row){return row.width===intent.width;});
      if(intent.layout) rows=rows.filter(function(row){return row.layout===intent.layout;});
      else if(intent.basinCount===1) rows=rows.filter(function(row){return row.layout!=='double';});
      else if(intent.basinCount===2) rows=rows.filter(function(row){return row.layout==='double';});
      if(!rows.length && intent.width!==null && intent.width>=data.custom_width.min && intent.width<=data.custom_width.max){
        return [{width:intent.width,layout:intent.layout,custom:true,requestedBasinCount:intent.basinCount}];
      }
      return rows;
    }

    function allowedSystems(base){
      if(!base) return [];
      if(base.custom) return data.systems.filter(function(system){return system.id===data.custom_width.system;});
      var key=base.width+':'+base.layout;
      return data.systems.filter(function(system){return !!system.nodes[key];});
    }

    function minBasePrice(base){
      var prices=allowedSystems(base).map(function(system){
        if(base.custom) return null;
        var node=system.nodes[base.width+':'+base.layout];
        return node && node.price != null ? node.price : null;
      }).filter(function(x){return x != null && Number.isFinite(Number(x));});
      return prices.length ? Math.min.apply(null,prices) : null;
    }

    function resultCell(label,value,state){
      return '<div class="adp-thea-result-cell '+state+'"><span>'+esc(label)+'</span><strong>'+esc(value)+'</strong></div>';
    }

    function systemLabel(system){
      return system.id==='ceramic'?'Ceramic':system.id==='benchtop'?'Benchtop':system.id==='imperial'?'Imperial':'Cabinet only';
    }

    function openDescribeFields(intent){
      var open=[];
      if(intent.width===null) open.push('width');
      if(intent.basinCount===null) open.push('basin count');
      if(!intent.layout) open.push('bowl position');
      return open;
    }

    function renderResults(){
      var intent=describeIntent();
      if(!intent.q){
        results.hidden=true;
        results.replaceChildren();
        return;
      }

      results.hidden=false;
      var rows=parseDescribe(intent);
      var header='<div class="adp-thea-result-head"><span>';
      if(intent.invalidWidth){
        results.innerHTML=header+'Custom width outside Thea range</span><small>Benchtop custom width is '+data.custom_width.min+'–'+data.custom_width.max+'mm.</small></div>'+
          '<div class="adp-thea-result-empty"><strong>'+esc(intent.width)+'mm is outside the published custom-width range.</strong><span>Depth and height remain fixed; only width is made to suit.</span></div>';
        return;
      }
      if(!intent.hasCore){
        results.innerHTML=header+'Describe the base first</span><small>Start with a width, basin count or bowl position.</small></div>';
        return;
      }
      if(!rows.length){
        results.innerHTML=header+'No exact standard base match</span><small>Try another standard layout or enter a custom Benchtop width.</small></div>'+
          '<div class="adp-thea-result-empty"><strong>No published standard Thea base matches these conditions.</strong><span>Custom width is available on the Benchtop path, but bowl position still requires supplier fit confirmation.</span></div>';
        return;
      }

      var open=openDescribeFields(intent);
      var openHtml=open.length?'<div class="adp-thea-result-open"><span>Still open in your description</span>'+open.map(function(x){return '<b>'+esc(x)+'</b>';}).join('')+'</div>':'';
      var headings='<div class="adp-thea-result-columns" aria-hidden="true"><div class="adp-thea-result-columns__main"><span>Width</span><span>Mounting</span><span>Basins</span><span>Bowl</span><span>Top paths</span></div><div class="adp-thea-result-columns__meta"><span>Starting</span><span>Commercial</span></div></div>';

      results.innerHTML=
        header+rows.length+' matching base configuration'+(rows.length===1?'':'s')+'</span><small>Top system is chosen in Configure.</small></div>'+
        openHtml+headings+
        '<div class="adp-thea-result-list">'+rows.map(function(row){
          var systems=allowedSystems(row);
          var price=minBasePrice(row);
          var basinValue=row.custom
            ? (row.requestedBasinCount ? row.requestedBasinCount+' requested' : 'To confirm')
            : (row.layout==='double'?'2 basins':'1 basin');
          var bowlValue=row.custom
            ? (row.layout ? titleLayout(row.layout)+' requested' : 'To confirm')
            : titleLayout(row.layout);
          var topPaths=systems.map(systemLabel).join(' / ');
          var widthState=intent.width!==null?'is-hit':'is-open';
          var basinState=(intent.basinCount!==null || intent.layout)?'is-hit':'is-open';
          var bowlState=intent.layout?'is-hit':'is-open';
          var customNote=row.custom?'Custom width · surcharge applies · cabinet made to suit':'Standard width intent';
          return '<button type="button" class="adp-thea-result-row" data-thea-width="'+row.width+'" data-thea-layout="'+esc(row.layout||'')+'" data-thea-custom="'+(row.custom?'true':'false')+'">'+
            '<div class="adp-thea-result-row__main">'+
              resultCell('Width',row.width+' mm',widthState)+
              resultCell('Mounting','Wall Hung','is-fixed')+
              resultCell('Basins',basinValue,basinState)+
              resultCell('Bowl',bowlValue,bowlState)+
              resultCell('Top',topPaths,'is-open')+
            '</div>'+
            '<div class="adp-thea-result-row__meta">'+
              '<div><span>Starting</span><strong>'+(row.custom?'Quote':('from '+money(price)))+'</strong></div>'+
              '<div><span>Commercial</span><strong>'+(row.custom?'Supplier quote':'Resolves after top')+'</strong><small>'+esc(customNote)+'</small></div>'+
            '</div>'+
          '</button>';
        }).join('')+'</div>';
    }

    function currentSystem(){ return byId(data.systems,state.system); }
    function currentNode(){
      var system=currentSystem();
      if(!system || !state.base || state.base.custom) return null;
      return system.nodes[state.base.width+':'+state.base.layout] || null;
    }
    function currentTop(){ return byId(data.top_finishes,state.topFinish); }
    function currentImperial(){ return byId(data.imperial_finishes,state.imperialFinish); }
    function currentUpgrade(){ return byId(data.benchtop_upgrades,state.benchtopUpgrade); }
    function basinChoicesForCurrentBase(){
      if(!state.base) return [];
      if(state.base.custom || !basinCatalog.length) return data.basins || [];
      var key=state.base.width+':'+state.base.layout;
      var none=(data.basins || []).filter(function(item){return item.explicit_none;});
      return none.concat(basinCatalog.filter(function(item){
        return (item.available_on || []).indexOf(key)!==-1;
      }));
    }
    function currentBasin(){ return byId(basinChoicesForCurrentBase(),state.basin); }
    function currentHandle(){ return byId(handleCatalog,state.handle); }
    function currentWaste(){ return byId(data.wastes,state.wasteUpgrade); }

    function priceInfo(){
      var node=currentNode();
      if(!node || node.quote_only || !node.sku || node.price == null) return {value:null,quote:true,label:'Quote required'};
      var value=Number(node.price || 0);
      var top=currentTop();
      var upgrade=currentUpgrade();
      var basin=currentBasin();
      var waste=currentWaste();
      var surchargeNote='';
      var isBenchtopDouble=state.system==='benchtop' && state.base && state.base.layout==='double';
      if(state.system==='benchtop' && top && Number(top.surcharge_percent||0)>0){
        surchargeNote=' + '+Number(top.surcharge_percent)+'% '+top.material+' surcharge';
      }
      if(state.system==='benchtop' && upgrade) value+=Number(upgrade.price||0);
      if(state.system==='benchtop' && basin && !basin.explicit_none && !basin.quote_only){
        value+=Number(basin.price||0)*(basin.multiply && isBenchtopDouble ? 2 : 1);
      }
      if(waste) value+=Number(waste.price||0)*(isBenchtopDouble ? 2 : 1);
      var quote=!!(state.base && state.base.custom) || !!surchargeNote || !!(currentHandle() && currentHandle().quote_only) || !!(basin && basin.quote_only);
      return {value:value,quote:quote,label:money(value)+surchargeNote+(quote && !surchargeNote?' + quote items':'')};
    }

    function tapVisual(id){
      var holes='';
      var position={'one-10':[67,31],'one-12':[88,24],'one-2':[109,31]};
      if(position[id]) holes='<circle cx="'+position[id][0]+'" cy="'+position[id][1]+'" r="4.2"></circle>';
      if(id==='three') holes='<circle cx="67" cy="24" r="4.2"></circle><circle cx="88" cy="24" r="4.2"></circle><circle cx="109" cy="24" r="4.2"></circle>';
      return '<span class="adp-thea-tap-visual" aria-hidden="true"><svg viewBox="0 0 200 104" focusable="false"><rect x="12" y="16" width="176" height="80" rx="3" fill="#d8cdc1"></rect><rect x="8" y="8" width="184" height="78" rx="4" fill="#f7f1ea" stroke="#b7aa9d"></rect><path data-tap-basin-outline="solid" fill="#483d33" fill-rule="evenodd" d="M146 62 A58 24 0 1 0 30 62 A58 24 0 1 0 146 62 Z M142.8 62 A54.8 20.8 0 1 1 33.2 62 A54.8 20.8 0 1 1 142.8 62 Z"></path><g fill="#6a4b39">'+holes+'</g></svg></span>';
    }
    function optionCard(field,item,selected,meta){
      var image=item.image ? '<span class="adp-thea-visual-option__image"><img src="'+esc(item.image)+'" alt="" loading="lazy"></span>' :
        field==='tapHole' ? tapVisual(item.id) : '<span class="adp-thea-visual-option__image adp-thea-visual-option__image--none" aria-hidden="true"><span>'+esc(item.explicit_none?'None':item.quote_only?'At quote':item.id==='standard'?'Standard':item.name)+'</span></span>';
      return '<button type="button" class="adp-thea-choice adp-thea-visual-option'+(selected?' is-selected':'')+'" aria-pressed="'+selected+'" data-thea-field="'+field+'" data-thea-value="'+esc(item.id)+'">'+
        image+'<span class="adp-thea-choice__copy adp-thea-visual-option__copy"><strong>'+esc(item.name)+'</strong>'+(meta?'<small>'+esc(meta)+'</small>':'')+'</span>'+
      '</button>';
    }
    function factCard(title,body){
      return '<div class="adp-thea-fact"><strong>'+esc(title)+'</strong>'+(body?'<span>'+esc(body)+'</span>':'')+'</div>';
    }
    function group(title,note,html,extraClass){
      var match=html.match(/data-thea-field="([^"]+)"/);
      var key=match?match[1]:'fixed-'+title.toLowerCase().replace(/[^a-z0-9]+/g,'-');
      var count=(html.match(/data-thea-field=/g)||[]).length;
      var status=count?(state[key]?'1 selected':key==='wasteUpgrade'?'Chrome included':'Choose one'):'Included / fixed';
      return '<section class="adp-thea-config-group adp-thea-visual-group '+(extraClass||'')+'" data-thea-group="'+esc(key)+'"><div class="adp-thea-config-group__head adp-thea-visual-group__heading"><div><h3>'+esc(title)+'</h3>'+(note?'<p>'+esc(note)+'</p>':'')+'</div><em>'+status+'</em></div><div class="adp-thea-choice-grid adp-thea-visual-group__options">'+html+'</div></section>';
    }

    function applyChoiceDisclosure(){
      groups.querySelectorAll('[data-thea-group]').forEach(function(section){
        var key=section.dataset.theaGroup;
        var grid=section.querySelector('.adp-thea-choice-grid');
        var cards=Array.from(grid.querySelectorAll('[data-thea-field]'));
        if(cards.length<=8) return;
        var expanded=!!view.expanded[key];
        var shown=cards.slice(0,8);
        var selected=cards.find(function(card){return card.getAttribute('aria-pressed')==='true';});
        if(selected && shown.indexOf(selected)<0) shown[shown.length-1]=selected;
        cards.forEach(function(card){card.hidden=!expanded && shown.indexOf(card)<0;});
        grid.id='adp-thea-options-'+key;
        if(!expanded){
          var preview=document.createElement('div');
          preview.className='adp-thea-visual-group__preview';
          preview.setAttribute('aria-hidden','true');
          preview.setAttribute('inert','');
          cards.filter(function(card){return shown.indexOf(card)<0;}).slice(0,8).forEach(function(card){
            var copy=card.cloneNode(true);copy.hidden=false;copy.disabled=true;
            copy.removeAttribute('data-thea-field');copy.removeAttribute('data-thea-value');
            copy.removeAttribute('aria-pressed');copy.setAttribute('tabindex','-1');preview.appendChild(copy);
          });
          grid.after(preview);
          section.classList.add('has-collapsed-preview');
        }
        var toggle=document.createElement('button');
        toggle.type='button';toggle.className='adp-thea-visual-configure__more';
        toggle.dataset.theaExpand=key;toggle.setAttribute('aria-expanded',String(expanded));
        toggle.setAttribute('aria-controls',grid.id);
        toggle.textContent=expanded?'Show fewer':'View all '+cards.length;
        section.appendChild(toggle);
      });
    }

    function renderSystemGroup(){
      var systems=allowedSystems(state.base);
      if(state.base && state.base.custom){
        state.system='benchtop';
        return group('Top system','Custom width is published on the Thea Benchtop order form only.',factCard('Benchtop + Separate Basin','Required by the selected custom-width path.'),'adp-thea-config-group--fixed');
      }
      return group('Top system','Choose your top first. The basin, drilling options and dimensions will follow this choice.',systems.map(function(system){
        return optionCard('system',system,state.system===system.id,system.note);
      }).join(''));
    }

    function renderCabinetGroup(){
      return group('Cabinet finish','Choose the finish for the largest visible surface on your vanity.',data.cabinet_finishes.map(function(item){
        return optionCard('cabinet',item,state.cabinet===item.id,'Included');
      }).join(''));
    }

    function renderBenchtop(){
      var top=currentTop();
      var topCards=data.top_finishes.map(function(item){
        var meta=item.material+(item.surcharge_percent?' · '+item.surcharge_percent+'% surcharge':'');
        return optionCard('topFinish',item,state.topFinish===item.id,meta);
      }).join('');
      var allowedUpgrades=data.benchtop_upgrades.filter(function(item){
        if(item.material && (!top || top.material!==item.material)) return false;
        if(item.max_width && state.base && Number(state.base.width)>Number(item.max_width)) return false;
        return true;
      });
      if(state.benchtopUpgrade && !allowedUpgrades.some(function(x){return x.id===state.benchtopUpgrade;})) state.benchtopUpgrade=null;
      return group('Benchtop finish','Choose the material and colour. Caesarstone Mineral carries ADP’s published 25% surcharge.',topCards)+
        group('Benchtop profile','Statement / Royale are Durasein-only. Statement is published to a 2m maximum.',allowedUpgrades.map(function(item){
          return optionCard('benchtopUpgrade',item,state.benchtopUpgrade===item.id,item.price?('+'+money(item.price)):'No profile upgrade');
        }).join(''))+
        (function(){
          var basins=basinChoicesForCurrentBase();
          var note=state.base.custom
            ? 'Custom widths require supplier compatibility confirmation. No basin compatibility is inferred.'
            : Math.max(0,basins.length-1)+' ADP basin products are compatible with this exact Thea width and bowl layout.';
          return group('Basin',note,basins.map(function(item){
            var meta=item.note || '';
            if(!item.explicit_none && !item.quote_only){
              var qty=item.multiply && state.base && state.base.layout==='double' ? 2 : 1;
              meta=qty===2 ? ('+'+money(Number(item.price||0)*2)+' · 2 × '+money(item.price)) : ('+'+money(item.price));
            }
            return optionCard('basin',item,state.basin===item.id,meta);
          }).join(''));
        })()+
        group('Tap hole drilling','No tap-hole choice is assumed.',data.tap_holes.benchtop.map(function(item){
          return optionCard('tapHole',item,state.tapHole===item.id,'Order-form instruction');
        }).join(''));
    }

    function renderCeramic(){
      return group('Ceramic top','The top and basin are integrated product facts.',factCard('Matte Ceramic','Integrated basin + front-position overflow'),'adp-thea-config-group--fixed')+
        group('Tap hole','ADP publishes 0, 10 o’clock and 2 o’clock for Ceramic.',data.tap_holes.ceramic.map(function(item){
          return optionCard('tapHole',item,state.tapHole===item.id,'Ceramic moulded top');
        }).join(''));
    }

    function renderImperial(){
      return group('Imperial top finish','Imperial is available only in Blossoming or Sakal Durasein.',data.imperial_finishes.map(function(item){
        return optionCard('imperialFinish',item,state.imperialFinish===item.id,'Integrated matte white basin');
      }).join(''))+
        group('Fixed Imperial facts','These are established by the selected top system.',factCard('0 tap hole','Supplied undrilled; may be drilled onsite')+factCard('Integrated basin','Matte white basin + overflow'),'adp-thea-config-group--fixed');
    }

    function renderCabinetOnly(){
      return group('Cabinet only','No benchtop is supplied on this branch.',factCard('No top','Basin and tap-hole configuration are not part of this product node.'),'adp-thea-config-group--fixed');
    }

    function renderHandleGroup(){
      return group('Handle','Thea currently exposes '+handleCatalog.length+' ADP handle choices. Premium handles are included at no extra charge.',handleCatalog.map(function(item){
        return optionCard('handle',item,state.handle===item.id,item.note || (item.quote_only?'Supplier compatibility check':'Included'));
      }).join(''));
    }

    function renderWasteGroup(){
      var chrome=byId(data.wastes,'chrome');
      var upgrades=data.wastes.filter(function(item){return item.id!=='chrome';});
      var html='<div class="adp-thea-choice adp-thea-visual-option adp-thea-choice--included"><span class="adp-thea-visual-option__image"><img src="'+esc(chrome.image)+'" alt="" loading="lazy"></span><span class="adp-thea-visual-option__copy"><strong>Chrome</strong><small>Included as standard</small></span></div>';
      html+=upgrades.map(function(item){
        return optionCard('wasteUpgrade',item,state.wasteUpgrade===item.id,'+'+money(item.price));
      }).join('');
      if(state.wasteUpgrade){
        html+='<button type="button" class="adp-thea-clear-choice" data-thea-clear-waste>Use included Chrome instead</button>';
      }
      return group('Plug & Waste','Chrome is an included standard feature. Only a colour upgrade is a customer choice.',html);
    }

    function renderFacts(){
      var facts=data.fixed_facts.slice();
      if(state.base && state.base.width===750) facts.push('750: Como Small organiser is not included');
      return group('Fixed Thea facts','These are not selectable options.',facts.map(function(x){return factCard(x,'');}).join(''),'adp-thea-config-group--facts adp-thea-config-group--fixed');
    }

    function renderGroups(){
      if(!state.base){ configurator.hidden=true; return; }
      configurator.hidden=false;
      var system=currentSystem();
      var html=renderSystemGroup()+renderCabinetGroup();
      if(system){
        if(system.id==='benchtop') html+=renderBenchtop();
        else if(system.id==='ceramic') html+=renderCeramic();
        else if(system.id==='imperial') html+=renderImperial();
        else if(system.id==='cabinet') html+=renderCabinetOnly();
      }
      html+=renderHandleGroup()+renderWasteGroup()+renderFacts();
      groups.innerHTML=html;
      applyChoiceDisclosure();
      refreshSummary();
    }

    function selectedFacts(){
      var facts=[];
      if(state.system) facts.push(['Top',currentSystem().name]);
      if(state.cabinet) facts.push(['Cabinet',byId(data.cabinet_finishes,state.cabinet).name]);
      if(state.system==='benchtop' && state.topFinish){
        var top=currentTop();
        facts.push(['Benchtop',top.name+' · '+top.material]);
      }
      if(state.system==='benchtop' && state.benchtopUpgrade) facts.push(['Profile',currentUpgrade().name]);
      if(state.system==='imperial' && state.imperialFinish) facts.push(['Imperial',currentImperial().name]);
      if(state.system==='benchtop' && state.basin){
        var basin=currentBasin();
        var basinQty=basin && basin.multiply && state.base && state.base.layout==='double' ? 2 : 1;
        facts.push(['Basin',basin ? (basin.name+(basinQty===2?' ×2':'')) : '']);
      }
      if(state.system==='ceramic') facts.push(['Basin',state.base && state.base.layout==='double'?'Integrated ceramic double bowl':'Integrated ceramic basin']);
      if(state.system==='imperial') facts.push(['Basin',state.base && state.base.layout==='double'?'Integrated matte white double bowl':'Integrated matte white basin']);
      if(state.tapHole){
        var list=state.system==='ceramic'?data.tap_holes.ceramic:data.tap_holes.benchtop;
        facts.push(['Tap',byId(list,state.tapHole).name]);
      } else if(state.system==='imperial') facts.push(['Tap','0 tap hole · fixed']);
      if(state.handle) facts.push(['Handle',currentHandle().name]);
      var wasteQty=state.system==='benchtop' && state.base && state.base.layout==='double' ? 2 : 1;
      if(state.wasteUpgrade) facts.push(['Waste',currentWaste().name+(wasteQty===2?' ×2':'')]);
      else facts.push(['Waste','Chrome'+(wasteQty===2?' ×2':'')+' · included']);
      return facts;
    }

    function missingFields(){
      var missing=[];
      if(!state.base) return ['Base configuration'];
      if(!state.system) missing.push('Top system');
      if(!state.cabinet) missing.push('Cabinet finish');
      if(!state.handle) missing.push('Handle');
      if(state.system==='ceramic' && !state.tapHole) missing.push('Tap hole');
      if(state.system==='imperial' && !state.imperialFinish) missing.push('Imperial top finish');
      if(state.system==='benchtop'){
        if(!state.topFinish) missing.push('Benchtop finish');
        if(!state.benchtopUpgrade) missing.push('Benchtop profile');
        if(!state.basin) missing.push('Basin');
        if(!state.tapHole) missing.push('Tap hole');
      }
      return missing;
    }

    function buildSummary(){
      if(!state.base) return 'Thea\nNo base selected.';
      var system=currentSystem();
      var node=currentNode();
      var p=priceInfo();
      var lines=[
        'ADP Thea',
        'Base: '+state.base.width+' mm · '+(state.base.custom?(state.base.layout?titleLayout(state.base.layout)+' bowl requested - supplier fit check':'Bowl layout to confirm'):(state.base.layout?titleLayout(state.base.layout)+' bowl':'Layout to confirm'))+' · Wall Hung'
      ];
      if(state.base.custom) lines.push('Custom width: supplier quote node ('+data.custom_width.min+'–'+data.custom_width.max+'mm published range; surcharge applies; cabinet made to suit)');
      if(system) lines.push('Top system: '+system.name);
      if(node){
        lines.push(node.sku ? 'SKU: '+node.sku : 'SKU: Supplier quote');
        lines.push('Nominal assembled size: '+node.width+'W × '+node.depth+'D × '+node.height+'H mm');
      } else lines.push('SKU: Quote required');
      selectedFacts().forEach(function(pair){ lines.push(pair[0]+': '+pair[1]); });
      lines.push('Power: Black in-drawer double power point · included');
      var missing=missingFields();
      if(missing.length) lines.push('Still to choose: '+missing.join(', '));
      lines.push('Current estimate: '+p.label);
      if((currentHandle()&&currentHandle().quote_only)||(currentBasin()&&currentBasin().quote_only)) lines.push('Quote check: supplier compatibility / selected quote-only nodes require confirmation.');
      return lines.join('\n');
    }

    function renderVisualSummary(){
      var items={
        Top:{field:'system',item:currentSystem()},
        Cabinet:{field:'cabinet',item:byId(data.cabinet_finishes,state.cabinet)},
        Benchtop:{field:'topFinish',item:currentTop()},
        Profile:{field:'benchtopUpgrade',item:currentUpgrade()},
        Imperial:{field:'imperialFinish',item:currentImperial()},
        Basin:{field:state.system==='benchtop'?'basin':'system',item:currentBasin()},
        Tap:{field:state.system==='imperial'?'system':'tapHole',tap:state.tapHole||'none'},
        Handle:{field:'handle',item:currentHandle()},
        Waste:{field:'wasteUpgrade',item:currentWaste()||byId(data.wastes,'chrome')}
      };
      stripChoices.innerHTML=selectedFacts().map(function(pair){
        var entry=items[pair[0]]||{field:'system'};
        var item=entry.item;
        var visual=entry.tap?tapVisual(entry.tap):item&&item.image?
          '<img src="'+esc(item.image)+'" alt="" loading="lazy">':
          '<span class="adp-thea-five__base-choice-none" aria-hidden="true">'+esc(item&&item.explicit_none?'None':item&&item.quote_only?'At quote':pair[0]==='Basin'?'Integrated':pair[0]==='Profile'?'Profile':pair[0])+'</span>';
        return '<button type="button" class="adp-thea-five__base-choice" data-thea-jump="'+entry.field+'" aria-label="Review '+esc(pair[0]+': '+pair[1])+'">'+visual+'<span><small>'+esc(pair[0])+'</small>'+esc(pair[1])+'</span></button>';
      }).join('');
    }

    function updateStripPin(){
      if(!state.base || strip.hidden || configurator.hidden){
        strip.classList.remove('is-pinned');stripAnchor.style.height='';return;
      }
      var offset=window.innerWidth<=720?8:16;
      var anchor=stripAnchor.getBoundingClientRect();
      var bounds=configurator.getBoundingClientRect();
      var pin=anchor.top<=offset && bounds.bottom>strip.offsetHeight+offset+24;
      if(pin){
        strip.style.setProperty('--thea-base-strip-left',anchor.left+'px');
        strip.style.setProperty('--thea-base-strip-width',anchor.width+'px');
        strip.classList.add('is-pinned');
        stripAnchor.style.height=strip.offsetHeight+'px';
      }else{
        strip.classList.remove('is-pinned');stripAnchor.style.height='';
        strip.style.removeProperty('--thea-base-strip-left');strip.style.removeProperty('--thea-base-strip-width');
      }
    }

    function refreshSummary(){
      if(!state.base) return;
      var node=currentNode();
      var p=priceInfo();
      baseText.textContent=state.base.width+' mm · '+(state.base.custom?(state.base.layout?titleLayout(state.base.layout)+' requested':'Bowl layout to confirm'):(state.base.layout?titleLayout(state.base.layout)+' bowl':'Layout to confirm'))+' · Wall Hung';
      strip.hidden=false;
      stripText.textContent=baseText.textContent+(state.system?' · '+currentSystem().name:'')+(node?' · '+node.width+'W × '+node.depth+'D × '+node.height+'H mm':'');
      stripDimensions.textContent=node ? node.width+'W × '+node.depth+'D × '+node.height+'H mm' : 'Custom · dimensions to quote';
      stripSku.textContent=node && node.sku ? 'SKU: '+node.sku : 'SKU: Supplier quote';
      stripPrice.textContent=p.label;
      priceEl.textContent=p.label;
      renderVisualSummary();
      var missing=missingFields();
      var status='<div class="adp-thea-config-status '+(missing.length?'is-incomplete':'is-complete')+'">'+
        '<strong>'+(missing.length?'Configuration incomplete':'Configuration ready for quote')+'</strong>'+
        '<span>'+(missing.length?'Still to choose: '+esc(missing.join(', ')):'All required customer choices are present. Quote-only nodes remain clearly marked.')+'</span>'+
      '</div>';
      var old=groups.querySelector('.adp-thea-config-status');
      if(old) old.remove();
      groups.insertAdjacentHTML('beforeend',status);
      continueQuote.disabled=missing.length>0;
      quoteSummary.value=buildSummary();
      updateStripPin();
    }

    results.addEventListener('click',function(event){
      var button=event.target.closest('[data-thea-width]');
      if(!button) return;
      results.querySelectorAll('.adp-thea-result-row.is-selected').forEach(function(row){row.classList.remove('is-selected');row.removeAttribute('aria-selected');});
      button.classList.add('is-selected');
      button.setAttribute('aria-selected','true');
      state.base={
        width:Number(button.dataset.theaWidth),
        layout:button.dataset.theaLayout || null,
        custom:button.dataset.theaCustom==='true'
      };
      state.system=state.base.custom ? 'benchtop' : null;
      state.cabinet=null;
      state.handle=null;
      state.wasteUpgrade=null;
      resetDependent();
      if(state.base.custom) state.system='benchtop';
      renderGroups();
      configurator.scrollIntoView({behavior:'smooth',block:'start'});
    });

    groups.addEventListener('click',function(event){
      var toggle=event.target.closest('[data-thea-expand]');
      if(toggle){
        var key=toggle.dataset.theaExpand;
        view.expanded[key]=!view.expanded[key];
        renderGroups();
        var refreshed=groups.querySelector('[data-thea-expand="'+CSS.escape(key)+'"]');
        if(refreshed) refreshed.focus({preventScroll:true});
        return;
      }
      var clear=event.target.closest('[data-thea-clear-waste]');
      if(clear){
        state.wasteUpgrade=null;
        renderGroups();
        return;
      }
      var button=event.target.closest('[data-thea-field]');
      if(!button) return;
      var field=button.dataset.theaField;
      var value=button.dataset.theaValue;
      if(field==='system'){
        if(state.system!==value){ state.system=value; resetDependent(); }
      } else {
        state[field]=value;
        if(field==='topFinish'){
          var top=currentTop();
          var up=currentUpgrade();
          if(up && up.material && top && up.material!==top.material) state.benchtopUpgrade=null;
        }
      }
      renderGroups();
      var selected=groups.querySelector('[data-thea-field="'+CSS.escape(field)+'"][data-thea-value="'+CSS.escape(value)+'"]');
      if(selected) selected.focus({preventScroll:true});
    });

    stripChoices.addEventListener('click',function(event){
      var button=event.target.closest('[data-thea-jump]');
      if(!button) return;
      var section=groups.querySelector('[data-thea-group="'+CSS.escape(button.dataset.theaJump)+'"]');
      if(!section) return;
      var top=section.getBoundingClientRect().top+window.scrollY-strip.offsetHeight-32;
      window.scrollTo({top:Math.max(0,top),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    });
    var pinFrame=0;
    function schedulePin(){
      if(pinFrame) return;
      pinFrame=window.requestAnimationFrame(function(){pinFrame=0;updateStripPin();});
    }
    window.addEventListener('resize',schedulePin);
    document.addEventListener('scroll',schedulePin,{passive:true,capture:true});
    if(window.ResizeObserver) new ResizeObserver(schedulePin).observe(strip);

    var describeTimer=0;
    var composingDescribe=false;
    function scheduleDescribe(){
      if(describeTimer){window.clearTimeout(describeTimer);describeTimer=0;}
      if(!input || !input.value.trim()){renderResults();return;}
      describeTimer=window.setTimeout(function(){describeTimer=0;renderResults();},450);
    }
    if(input){
      input.addEventListener('input',scheduleDescribe);
      input.addEventListener('compositionstart',function(){composingDescribe=true;if(describeTimer){window.clearTimeout(describeTimer);describeTimer=0;}});
      input.addEventListener('compositionend',function(){composingDescribe=false;scheduleDescribe();});
      input.addEventListener('keydown',function(event){
        if(event.key==='Enter' && !event.shiftKey && !composingDescribe && !event.isComposing){
          event.preventDefault();
          if(describeTimer){window.clearTimeout(describeTimer);describeTimer=0;}
          renderResults();
        }
      });
    }
    if(clearDescribe) clearDescribe.addEventListener('click',function(){
      if(describeTimer){window.clearTimeout(describeTimer);describeTimer=0;}
      input.value='';
      renderResults();
      input.focus();
    });
    if(changeBase) changeBase.addEventListener('click',function(){
      state.base=null; state.system=null; state.cabinet=null; state.handle=null; state.wasteUpgrade=null; resetDependent();
      configurator.hidden=true;
      strip.hidden=true;
      updateStripPin();
      renderResults();
      results.scrollIntoView({behavior:'smooth',block:'start'});
    });
    if(continueQuote) continueQuote.addEventListener('click',function(){
      if(this.disabled) return;
      root.querySelector('[data-adp-thea-quote]').scrollIntoView({behavior:'smooth',block:'start'});
    });
    if(copySummary) copySummary.addEventListener('click',function(){
      var text=quoteSummary.value;
      if(navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text);
      else { quoteSummary.focus(); quoteSummary.select(); document.execCommand('copy'); }
    });

    renderResults();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})(window,document);
